import { getDfCpdValidation } from "@features/builder/graph/nodes/validation/pure/getDfCpdValidationState"
import type { ValidationState } from "@features/builder/graph/nodes/validation/types"
import { DfCpd } from "@store/services/converter/types"
import { useMemo } from "react"

type UseDfCpdPropertiesValidationArgs = {
  dfCpd: DfCpd
  /**
   * Whether the node has at least one child. Geometric and Logseries require
   * `ubound` only in that case. Mandatory so a caller cannot silently validate a
   * parent as a leaf.
   */
  hasChildren: boolean
}

export function useDfCpdPropertiesValidation({
  dfCpd,
  hasChildren,
}: UseDfCpdPropertiesValidationArgs): ValidationState["errors"] {
  return useMemo(() => getDfCpdValidation(dfCpd, { hasChildren }).errors, [dfCpd, hasChildren])
}
